import React from "react";

export default function Bio() {
  return (
    <section
      className="border-t border-border bg-[hsl(var(--surface))]"
      data-testid="bio-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-5">
          <figure className="reveal">
            <div className="aspect-[4/5] overflow-hidden bg-background">
              <img
                src="https://customer-assets.emergentagent.com/job_black-western-studio/artifacts/n4rwv6qh_DJI_20260119_113247_139.JPG"
                alt="Joseph Graves Jr. — beside his mural in Denver"
                className="w-full h-full object-cover"
              />
            </div>
            <figcaption className="label mt-3">
              Beside the mural · Denver
            </figcaption>
          </figure>
        </div>

        <div className="md:col-span-7 flex flex-col justify-center reveal">
          <p className="label mb-4">About the Artist</p>
          <h2 className="serif text-4xl md:text-5xl leading-[1.05] tracking-tight font-light">
            The man behind the canvas.
          </h2>

          <div className="mt-8 space-y-6 text-[hsl(var(--ink-soft))] leading-relaxed max-w-2xl">
            <p>
              <span className="text-foreground font-medium">
                Joseph Graves Jr.
              </span>{" "}
              is a Denver-based fine artist whose work spans figurative
              painting, Black Western imagery, and abstract contemporary art.
              Drawing on themes of identity, history, and cultural pride, his
              paintings bring visibility to stories and figures often overlooked
              by mainstream art institutions.
            </p>
            <p>
              Beyond the canvas, Joseph is an educator and community builder —
              offering art lessons, live event painting, and programming that
              connects people of all ages to the power of creative expression.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
            <Stat n="60+" label="Originals" />
            <Stat n="12" label="Exhibitions" />
            <Stat n="7yr" label="Practice" />
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ n, label }) {
  return (
    <div>
      <div className="serif text-3xl md:text-4xl">{n}</div>
      <div className="label mt-1">{label}</div>
    </div>
  );
}
